import { Button, Stack, Tab, Tabs } from "@mui/material";
import DateRangePicker from "src/components/shared/DateRangePicker";
import useQueryParams from "src/hooks/useQueryParams";
import { DebtSalesAllTab, DebtSalesUnpaidTab, DebtSalesOverdueTab, DebtSalesHistoryTab } from "./Tabs";
import { useState } from "react";
import ExportIcon from "src/components/shared/icon/ExportIcon";

const debtSalesTab = [
  { id: "all", name: "Tất cả" },
  { id: "unpaid", name: "Công nợ chưa thanh toán" },
  { id: "overdue", name: "Cảnh báo vượt công nợ" },
  { id: "history", name: "Lịch sử thanh toán công nợ" },
];

function CustomTabPanel(props) {
  const { children, value, id, ...other } = props;
  return <>{value === id && children}</>;
}

const DebtSalesList = () => {
  const [option, setOption] = useQueryParams();
  const [date, setDate] = useState({ fromDate: null, toDate: null });
  const subTab = option?.subTab ?? debtSalesTab[0].id;

  const handleTabChange = (_, value) => {
    setOption({ ...option, subTab: value });
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-end"
        gap={2}
        mt="24px"
      >
        <DateRangePicker
          value={date}
          onApply={setDate}
          label="Thời gian phát sinh CNK"
        />
        <Button
          variant="contained"
          startIcon={<ExportIcon />}
        >
          Xuất File
        </Button>
      </Stack>
      <Tabs
        value={subTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: "1px solid var(--grey)" }}
      >
        {debtSalesTab.map((v) => (
          <Tab
            value={v.id}
            key={v.id}
            label={v.name}
            sx={{
              p: "4px 16px !important",
              borderBottom: subTab === v.id ? "2px solid" : "",
            }}
          />
        ))}
      </Tabs>
      <CustomTabPanel
        value={subTab}
        id={debtSalesTab[0].id}
      >
        <DebtSalesAllTab date={date} />
      </CustomTabPanel>
      <CustomTabPanel
        value={subTab}
        id={debtSalesTab[1].id}
      >
        <DebtSalesUnpaidTab date={date} />
      </CustomTabPanel>
      <CustomTabPanel
        value={subTab}
        id={debtSalesTab[2].id}
      >
        <DebtSalesOverdueTab date={date} />
      </CustomTabPanel>
      <CustomTabPanel
        value={subTab}
        id={debtSalesTab[3].id}
      >
        <DebtSalesHistoryTab date={date} />
      </CustomTabPanel>
    </>
  );
};

export default DebtSalesList;
